<template>
  <el-container>
    <el-header style="padding: 0; min-height: 30px;">
      <el-page-header @back="goBack" :content="pageTitle">
      </el-page-header>
    </el-header>
    
    <el-main>
      <el-steps :active="step" simple class="t_top">
        <el-step title="第一步：课程基本信息" icon="el-icon-edit"></el-step>
        <el-step title="第二步：课程简介" icon="el-icon-upload"></el-step>
        <el-step title="第三步：课程内容" icon="el-icon-picture"></el-step>
      </el-steps>
      
      <template v-if="step == 1">
        <el-form ref="courseForm" :model="form" :rules="rules" label-width="147px" class="demo-ruleForm t_center"
                 align="left">
          <el-form-item label="课程名称:" prop="courseName">
            <!--@input="searchCommodityinfoByAll"-->
            <el-input v-model="form.courseName" placeholder="课程名称" @input="searchCommodityinfoByAll" ></el-input>
          </el-form-item>
          <el-form-item label="课程英文名称:" prop="courseEnglishName" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.courseEnglishName" placeholder="课程名称" @input="searchCommodityinfoByAll" ></el-input>
          </el-form-item>
          <el-form-item label="课程俄语名称:" prop="courseRussianName" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.courseRussianName" placeholder="课程俄语名称"></el-input>
          </el-form-item>
          <el-form-item label="课程西班牙语名称:" prop="courseSpanishName" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.courseSpanishName" placeholder="课程西班牙语名称"></el-input>
          </el-form-item>          
          <el-form-item label="主营类目:" :inline="true"  prop="ccId" style="width: 100%" v-if="loginOrgCode != 'blcuonline'">
            <el-cascader
                expand-trigger="hover"
                change-on-select="true"
                :options="categoryOptions"
                v-model="selectedCategory"
                :props="{ value: 'ccId', label: 'ccName'}"
                @change="changeCategory">
            </el-cascader>
          </el-form-item>
          <!--<el-form-item v-if="orgType != 1" label="机构类目:" prop="ccId"  style="width: 70%">-->
            <!--<el-col :span="11">-->
              <!--<el-select size="small" v-model="form.ccPId" placeholder="一级分类" @change="changeCourse"-->
                         <!--:disabled="this.disableCourse">-->
                <!--<el-option v-for=" c in courseData " :label="c.ccName" :value="c.ccId"></el-option>-->
              <!--</el-select>-->
            <!--</el-col>-->
            <!--<el-col :span="11">-->
              <!--<el-select size="small" v-model="form.ccId" placeholder="二级分类" :disabled="this.disableCourse"-->
                         <!--@change="changeChildrenCourse">-->
                <!--<el-option v-for=" c in courseChild " :label="c.ccName" :value="c.ccId"></el-option>-->
              <!--</el-select>-->
            <!--</el-col>-->
          <!--</el-form-item>-->
          <el-form-item label="特色介绍:" prop="introduce">
            <el-input v-model="form.introduce" placeholder="特色介绍"></el-input>
          </el-form-item>
          <el-form-item label="英文特色介绍:" prop="englishIntroduce" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.englishIntroduce" placeholder="特色介绍"></el-input>
          </el-form-item>
          <el-form-item label="俄语特色介绍:" prop="russianIntroduce" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.russianIntroduce" placeholder="俄语特色介绍"></el-input>
          </el-form-item> 
          <el-form-item label="西班牙语特色介绍:" prop="spanishIntroduce" v-if="loginOrgCode == 'blcuonline'">
            <el-input v-model="form.spanishIntroduce" placeholder="西班牙语特色介绍"></el-input>
          </el-form-item>                    
          <el-form-item label="商品型号:" prop="specType">
            <el-radio v-model="form.specType" :label="0" @change="changeSpecType">统一型号</el-radio>
            <el-radio v-model="form.specType" :label="1" @change="changeSpecType">多级型号</el-radio>
          </el-form-item>
          <el-form-item label="" v-if="form.specType == 1" class="specParent">
            <div v-for="(modelType,index) in modelTypeList" style="width: 100%; min-height: 100px;border:  1px solid rgba(215, 215, 215, 1);">
              <div style="width: 100%; height: 40px; line-height: 40px; background: rgba(242, 242, 242, 1);">
                <el-form-item label="型号分类:" :rules="[{ required: true, message: '请输入型号分类', trigger: 'blur' }]">
                  <el-input v-model="modelType.specName" placeholder="型号分类"   size="small" style="width: 15%" :title="modelType.specName"
                            @keyup.enter.native="handleModelTypeInputConfirm(modelType)"
                            @blur="handleModelTypeInputConfirm(modelType)"
                  ></el-input>
                  <el-input v-model="modelType.specNameEn" placeholder="英文型号分类" size="small" style="width: 19%;" :title="modelType.specNameEn"
                            @keyup.enter.native="handleModelTypeInputConfirmEn(modelType)"
                            @blur="handleModelTypeInputConfirmEn(modelType)"
                  ></el-input>
                  <el-input v-model="modelType.specNameRus" placeholder="俄语型号分类" size="small" style="width: 30%;" :title="modelType.specNameRus"
                            @keyup.enter.native="handleModelTypeInputConfirmRus(modelType)"
                            @blur="handleModelTypeInputConfirmRus(modelType)"
                  ></el-input> 
                  <el-input v-model="modelType.specNameSpa" placeholder="西班牙语型号分类" size="small" style="width: 30%;" :title="modelType.specNameSpa"
                            @keyup.enter.native="handleModelTypeInputConfirmSpa(modelType)"
                            @blur="handleModelTypeInputConfirmSpa(modelType)"
                  ></el-input>                                    
                  <el-button @click="deleteModelType(modelType)" type="text" size="small" style="float: right; margin-right: 10px;margin-top: 6px;">删除</el-button>
                </el-form-item>
              </div>
              <div v-if="modelType.specName">
                <el-form-item label="型号:" >
                  <draggable filter=".undraggable" @update="sortDynamicTags($event,modelType,index)" style="display: inline" >
                    
                    <el-tag
                        :key="tag.key"
                        v-for="tag in modelType.specOptionVoList"
                        closable
                        :disable-transitions="false"
                        @close="handleTagClose(tag, modelType.specOptionVoList)">
                        {{tag.specOptionName}}<span v-if="tag.specOptionNameEn">({{tag.specOptionNameEn}})</span>
                    </el-tag>
                    <el-popover
                        v-model="modelType.inputVisible"
                        width="1073"
                        trigger="click"
                    >
                      <el-input v-model="modelType.inputValue" placeholder="型号名称" size="small" style="width: 14%; margin-left: -9px;" :title="modelType.inputValue"></el-input>
                      <el-input v-model="modelType.inputValue2" placeholder="英文型号名称" size="small" style="width: 21%;" :title="modelType.inputValue2"></el-input>
                      <el-input v-model="modelType.inputValue3" placeholder="俄语型号名称" size="small" style="width: 30%;" :title="modelType.inputValue3"></el-input>
                      <el-input v-model="modelType.inputValue4" placeholder="西班牙语型号名称" size="small" style="width: 30%;" :title="modelType.inputValue4"></el-input>
                      <el-button type="success" size="small" plain @click="handleInputConfirm(modelType)">
                        确认
                      </el-button>
                    </el-popover>
                  </draggable>
                  <el-button class="button-new-tag undraggable" size="small"  @click="showInput(modelType)">添加商品型号</el-button>
                </el-form-item>
              </div>
            </div>
    
            <el-button class="button-new-tag" size="small" @click="addModelTypeList" style="margin-left: 0">+添加型号分类</el-button>
          </el-form-item>
          <el-form-item label="价格" v-if="modelTypeListData.length != 0 && form.specType == 1">
            <el-table
                :data="modelTypeListData"
                :span-method="objectSpanMethod"
                max-height="500"
                border
            >
              <el-table-column
                  v-for="col in modelTypeList"
                  :prop="col.specName"
                  :label="col.specName"
                  v-if="col.specName"
                  fixed="left"
                  min-width="150"
                  align="center">
              </el-table-column>
              <el-table-column
                  prop="status"
                  label="是否启用"
                  fixed="left"
                  min-width="50"
                  align="center">
                <template slot-scope="scope">
                  <el-switch
                      v-model="scope.row.status"
                      active-color="#13ce66"
                      inactive-color="#ff4949"
                      :active-value="1"
                      :inactive-value="2"
                  ></el-switch>
                </template>
              </el-table-column>
              <el-table-column
                  prop="preferentialPrice"
                  label="优惠价"
                  width="180"
                  align="center"
              >
        
                <template slot="header" slot-scope="scope">
                  <span>优惠价</span><br>
                  <el-input v-model="value1"
                            size="small"
                            @input="validateNumber(value1,(data)=>{value1 = data})"
                            placeholder='请输入优惠价'
                            style="width: 80%"
                            @change="inputBlur1">
                  </el-input>
                </template>
        
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.preferentialPrice" @change="resetPrice1" placeholder="优惠价" size="small" style="width: 80%"
                            @input="validateNumber(row.preferentialPrice,(data)=>{row.preferentialPrice = data})"
                  ></el-input>
                </template>
              </el-table-column>
              <el-table-column
                  prop="price"
                  label="原价"
                  width="180"
                  align="center"
              >
                <template slot="header" slot-scope="scope">
                  <span><font color="#F56C6C">*</font>原价</span><br>
                  <el-input v-model="value2"
                            size="small"
                            @input="validateNumber(value2,(data)=>{value2 = data})"
                            placeholder='请输入原价'
                            style="width: 80%"
                            @change="inputBlur2">
                  </el-input>
                </template>
                <template slot-scope="{row,$index}">
                  <el-input v-model="row.price" @change="resetPrice2" placeholder="原价" size="small" style="width: 80%"
                            @input="validateNumber(row.price,(data)=>{row.price = data})"
                  ></el-input>
                </template>
              </el-table-column>
            </el-table>
          </el-form-item>
          <el-form-item label="原价:" prop="price" v-if="form.specType == 0" >
            <el-input v-model="form.price" placeholder="原价" ></el-input>
          </el-form-item>
  
          <el-form-item label="优惠价:"
                        v-if="form.specType == 0"
                        prop="preferential"
                        :key="form.preferentialBeginTime+form.preferentialEndTime"
          >
            <el-input v-model="form.preferential" placeholder="优惠价"></el-input>
            <span style="color: red; position: absolute;width: 250px;margin-left: 5px">*免费商品请将优惠价设置为0</span>
          </el-form-item>
          <el-form-item label="优惠时间:"
                        :required="form.preferentialBeginTime || form.preferentialEndTime?true:false"
          >
                <el-date-picker
                    v-model="form.preferentialBeginTime"
                    type="datetime"
                    placeholder="选择开始日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :append-to-body=false
                    :picker-options="startTime"
                >
                </el-date-picker>
                <span style="margin: 0px 10px;">-</span>
                <el-date-picker
                    v-model="form.preferentialEndTime"
                    :append-to-body=false
                    type="datetime"
                    placeholder="选择结束日期"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="endTime"
                >
                </el-date-picker>
          </el-form-item>
          <el-form-item label="课时标准:" prop="standard" v-if="loginOrgCode != 'blcuonline'">
            <el-input v-model="form.standard" placeholder="课时标准"></el-input>
          </el-form-item>
          <el-form-item label="购买人数:" prop="persionNum">
            <el-input v-model="form.persionNum" placeholder="购买人数"></el-input>
          </el-form-item>
          <el-form-item label="课时:" prop="classTime" >
            <el-input v-model="form.classTime" placeholder="课时"></el-input>
          </el-form-item>
          <el-form-item label="有效期:" prop="validity">
            <el-radio v-model="form.validityType" :label="1" @change="changeValidityType">永久</el-radio>
            <el-radio v-model="form.validityType" :label="2" @change="changeValidityType">
              <span class="input_">
                <el-input  v-model="form.validity" @input="checkValidity"  placeholder="有效期" >
                    <template slot="append">天</template>
                </el-input>
              </span>
            </el-radio>
          </el-form-item>
          <el-form-item label="开班日期:" prop="openClassTime">
            <el-radio v-model="form.openClassType" :label="1" @change="changeOpenClass">随时</el-radio>
            <el-radio v-model="form.openClassType" :label="2" @change="changeOpenClass">
              <el-date-picker
                  v-model="form.openClassTime"
                  type="date"
                  @change="changeOpenClass"
                  value-format="yyyy-MM-dd HH:mm:ss"
                  placeholder="选择日期">
              </el-date-picker>
            </el-radio>
          </el-form-item>
          <el-form-item label="授课类型:" prop="lessonType" v-if="loginOrgCode != 'blcuonline'">
            <el-select placeholder="" size="small" v-model="form.lessonType">
              <el-option label="直播" :value="1"></el-option>
              <el-option label="面授" :value="2"></el-option>
              <el-option label="录播" :value="3"></el-option>
              <el-option label="录播+直播" :value="4"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="汉语水平:"  v-if="loginOrgCode == 'blcuonline'">
            <el-select placeholder="" size="small" v-model="form.lessonType">
              <el-option label="入门" :value="11"></el-option>
              <el-option label="初级" :value="12"></el-option>
              <el-option label="中级" :value="13"></el-option>
              <el-option label="高级" :value="14"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="所属机构:" prop="orgCode" v-if="loginOrgCode != 'blcuonline'">
            <el-select size="small" placeholder="机构" v-model="form.orgCode" @change="changeOrgCode">
              <el-option v-for="o in org" :label="o.organizationName" :value="o.orgCode"></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="机构商品分类:" :inline="true" v-if="showOrgCC" prop="orgCcId" style="width: 100%">
            <el-cascader
                expand-trigger="hover"
                change-on-select="true"
                size="small"
                :options="categoryOrgOptions"
                :props="{ value: 'ccId', label: 'ccName'}"
                v-model="selectedOrgCategory"
                @change="changeCategory">
            </el-cascader>
          </el-form-item>
          <el-form-item label="关联商品推荐:" :inline="true" style="width: 100%">
            <choseCommodity buttonName="+关联商品"
                            v-if="reFresh"
                            title="请选择关联商品"
                            :orgCode="orgCode"
                            :categoryOptions="categoryOptions"
                            @changeCommodityList = "changeCommodityList"
                            :commodityList = "form.similarCommodityRecommendList"
                            :searchData="glSearchData"
            ></choseCommodity>
          </el-form-item>
          <el-form-item label="主讲老师:" prop="lecturer">
            <el-select v-model="form.lecturer"
                       multiple
                       filterable
                       style="width: 100%;"
                       placeholder="请选择">
              <el-option
                  v-for="item in teacherList"
                  :key="item.teacherId"
                  :label="item.teacherName"
                  :value="item.teacherId">
              </el-option>
            </el-select>
          </el-form-item>
          
          <el-form-item label="试听视频1:" prop="auditionVideoPath">
            <FileUpload
                @changeAuditionVideoStrList="changeAuditionVideoStrList"
                :auditionVideoStrListTemp = "form.auditionVideoStrList"
            >
            
            </FileUpload>
          </el-form-item>
          
          <el-form-item label="宣传视频1:" prop="auditionVideoPath">
            <div v-show="uploadMethodDataType == 1">
                <!-- <el-upload
                    :action="uploadURLP"
                    ref="auditionVideo"
                    :on-preview="handleAutoCardPreview"
                    :on-remove="auditionVideoHandleRemove"
                    :on-change="auditionVideoOnChange"
                    :on-success="auditionVideoHandleSuccess"
                    :before-upload="auditionVideoBeforeAvatarUpload"
                    :limit="1"
                    :file-list="auditionVideoFileList"
                    :show-file-list="true"
                    :auto-upload="false"
                    style="width: 50%"
                    :class="{'avatar-video': true, 'hide': hideAuditionVideoUpload}"
                > -->
                  <!-- <el-button slot="trigger" size="small" ref="selectFile" @click="uploadMethod(1)" type="primary">选取文件</el-button> -->
                  <el-button type="primary" size="small"  @click="uploadMethod(2)" style="margin-left: 10px;" class="but-cls">填写链接</el-button>
                  <!-- <div v-show="uploadMethodData == 1">
                      <div slot="tip" class="el-upload__tip">建议MP4格式，视频不宜太大</div>
                      <video controls="controls" style="display: none" id="aa" @canplaythrough="videoDuration(this)">
                      </video>
                      <el-progress :percentage="percent" status="success"></el-progress>
                  </div> -->
                <!-- </el-upload> -->
              
              <div v-show="uploadMethodData == 2">
                <el-form-item label="视频名称:" prop="pathName">
                  <el-input v-model="pathName" placeholder="视频名称" style="width: 50%; margin-bottom: 10px;"></el-input>
                </el-form-item>
                <el-form-item label="上传视频:" prop="auditionUpload">
                  <el-upload
                    v-model="auditionUpload"
                    name="upfile"
                    style="margin-bottom: 10px;"
                    class="upload-demo"
                    :headers="myHeaders"
                    :action="uploadURLP"
                    :on-preview="handleauditionUploadPreview"
                    :on-remove="handleauditionUploadRemove"
                    :before-remove="beforeauditionUploadRemove"
                    :on-success="HandleauditionUploadSuccess"
                    multiple
                    :limit="3"
                    :on-exceed="handleauditionUploadExceed"
                    :file-list="auditionUploadfileList">
                    <el-button size="small" type="primary">上传视频</el-button>
                    <!-- <div slot="tip" class="el-upload__tip">只能上传视频文件</div> -->
                  </el-upload>
                </el-form-item>
                <el-form-item label="视频路径:" prop="videoPath">
                  <el-input v-model="videoPath" placeholder="视频路径" style="width: 50%; margin-bottom: 10px;"></el-input>
                </el-form-item>
                <el-form-item label="封 面 图:" prop="filePicture">
                  <el-upload
                      v-model="filePicture"
                      ref='box'
                      :action="uploadURL"
                      :headers="myHeaders"
                      list-type="picture-card"
                      :on-preview="handleImageCardPreview"
                      :on-remove="imageHandleRemove"
                      :on-change="imageOnChange"
                      :on-success="imageHandleSuccess"
                      :on-error="onError"
                      :before-upload="imageBeforeAvatarUpload"
                      :limit="2"
                      :on-exceed="exceed"
                      :file-list="imageFileList"
                      :show-file-list="true"
                  >
                    <i class="el-icon-plus"></i>
                  </el-upload>
                  <el-dialog :visible.sync="dialogVisible" size="tiny">
                    <img width="100%" :src="dialogImageUrl" alt="">
                  </el-dialog>
                </el-form-item>
                <el-form-item align="center">
                  <el-button type="primary" size="small" @click="confirmUpload()" class="but-cls">确定上传</el-button>
                </el-form-item>
              </div>
              <el-dialog :visible.sync="dialogAuditionVideo" size="tiny" align="center">
              
              </el-dialog>
            </div>
            <div v-show="uploadMethodDataType == 2">
              <el-tag
                  v-if="form.auditionVideoVo"
                  :disable-transitions="false"
                  >
                {{form.auditionVideoVo.fileName}}
              </el-tag>
              <!--<div v-show="videoType == 0">
                <video controls="controls" :src="videoSrc" @canplaythrough="videoDuration(this)" style="width: 50%">
                </video>
              </div>
              <div v-show="videoType == 1">
                <ali-player v-if="loaded"  ref="player"
                            :vid = 'vid'
                            :playauth="playAuth"
                            :encryptType = 'encryptType'
                             ></ali-player>
                <div style="width: 50%; height: 200px" v-if="!loaded">
                  <img src="@/../public/loading1.gif" style="height: 200px" />
                </div>
              </div>-->
              <el-button type="primary" size="small" @click="reUpload()" class="but-cls" style="margin-left: 10px">
                重新上传
              </el-button>
            </div>
          </el-form-item>
          
          <el-form-item label="课程封面:" prop="picturePath">
            <el-upload
                v-model="form.picturePath"
                :action="uploadURL"
                :headers="myHeaders"
                list-type="picture-card"
                :on-preview="handlePictureCardPreview"
                :on-remove="pictureHandleRemove"
                :on-change="pictureOnChange"
                :on-success="pictureHandleSuccess"
                :on-error="onError"
                :before-upload="pictureBeforeAvatarUpload"
                :limit="2"
                :on-exceed="exceed"
                :file-list="pictureFileList"
                :show-file-list="true"
            >
              <i class="el-icon-plus"></i>
            </el-upload>
            <el-dialog :visible.sync="dialogVisible" size="tiny">
              <img width="100%" :src="dialogImageUrl" alt="">
            </el-dialog>
          </el-form-item>
          <el-form-item label="是否显示:" prop="isView">
            <el-radio v-model="form.isView" :label="1">显示</el-radio>
            <el-radio v-model="form.isView" :label="0">不显示</el-radio>
          </el-form-item>
          <el-form-item label="是否打包套餐:" prop="isPacking">
            <el-radio v-model="form.isPacking" :label="1">打包</el-radio>
            <el-radio v-model="form.isPacking" :label="0">不打包</el-radio>
          </el-form-item>
          <el-form-item label="自营排序:" prop="sort" v-if="orgType == 1">
            <el-input v-model="form.sort" placeholder="排序"></el-input>
          </el-form-item>
          <el-form-item label="机构排序:" prop="orgSort" v-if="showOrgCC">
            <el-input v-model="form.orgSort" placeholder="排序"></el-input>
          </el-form-item>
          <el-form-item label="咨询方式:" prop="contactInfo">
            <el-input v-model="form.contactInfo" placeholder="请输入咨询方式"></el-input>
          </el-form-item>
          <el-form-item label="组合优惠:">
            <div>
              <div>第一步  选组合关联商品（限20个）</div>
              <choseCommodity
                  buttonName="+组合商品"
                  :orgCode="orgCode"
                  title="请选择组合商品"
                  :categoryOptions="categoryOptions"
                  :commodityList="commodityList"
                  :searchData="searchData"
                  @changeCommodityList = "changeCommodityList1"
              ></choseCommodity>
              <div v-if="commodityTags.length > 0">第二步  组合优惠价设置</div>
              <el-table
                  :data="commodityTags"
                  style="width: 50%"
                  v-if="form.specType == 0 && commodityTags.length > 0"
                  border>
                <el-table-column
                    prop="commodityId"
                    label="组合商品"
                    width="180"
                    align="center"
                    :formatter="name_formatter">
                </el-table-column>
                <el-table-column
                    prop="price"
                    label="组合价"
                    align="center">
                  <template slot-scope="{row,$index}">
                    <el-input v-model="row.price" @change="changePrice" placeholder="组合价" size="small" style="width: 80%" @input="validateNumber(row.price,(data)=>{row.price = data})" maxLength='9'>
                      <template slot="append">元</template>
                    </el-input>
                  </template>
                </el-table-column>
    
              </el-table>
    
              <el-table
                  :data="modelTypeListData"
                  max-height="500"
                  :span-method="objectSpanMethod"
                  v-if="form.specType == 1 && commodityTags.length > 0"
                  border
              >
                <el-table-column
                    v-for="col in modelTypeList"
                    :prop="col.specName"
                    :label="col.specName"
                    fixed="left"
                    min-width="150"
                    align="center">
                </el-table-column>
                <el-table-column
                    v-for="(commodityTag, index) in commodityTags"
                    prop="commodityId"
                    width="230"
                    :index = "index"
                    :render-header="titleHeader"
                    align="center"
      
                >
                  <template slot-scope="{row,$index}">
                    <el-input v-model="row['price'+(index+1)]" @blur="changePrice1" placeholder="组合价" size="small" style="width: 80%" @input="validateNumber(row['price'+(index+1)],(data)=>{row['price'+(index+1)] = data})" maxLength='9'>
                      <template slot="append">元</template>
                    </el-input>
                  </template>
                </el-table-column>
              </el-table>
            </div>
          </el-form-item>
          <el-form-item align="center">
            <el-button type="primary" @click="saveAndNext(1)">保存，进入下一步</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="step == 2">
        <el-form ref="form" class="t_center1">
          <el-form-item label="简介:">
          </el-form-item>
          <el-form-item >
            <ckeditor v-model="form.courseIntroduce"></ckeditor>
          </el-form-item>
          <el-form-item label="英文简介:" v-if="loginOrgCode == 'blcuonline'">
          </el-form-item>
          <el-form-item  v-if="loginOrgCode == 'blcuonline'" style="margin-top: 15px; margin-bottom: 15px">
            <ckeditor v-model="form.courseEnglishIntroduce"></ckeditor>
          </el-form-item>
          <el-form-item label="俄语简介:" v-if="loginOrgCode == 'blcuonline'">
          </el-form-item>
          <el-form-item  v-if="loginOrgCode == 'blcuonline'" style="margin-top: 15px; margin-bottom: 15px">
            <ckeditor v-model="form.courseRussianIntroduce"></ckeditor>
          </el-form-item> 
          <el-form-item label="西班牙语简介:" v-if="loginOrgCode == 'blcuonline'">
          </el-form-item>
          <el-form-item  v-if="loginOrgCode == 'blcuonline'" style="margin-top: 15px; margin-bottom: 15px">
            <ckeditor v-model="form.courseSpanishIntroduce"></ckeditor>
          </el-form-item>                    
          <el-form-item align="center">
            <el-button @click="prev">上一步</el-button>
            <el-button type="primary" @click="saveAndNext(2)">保存，进入下一步</el-button>
          </el-form-item>
        </el-form>
      </template>
      <template v-if="step == 3">
        <step3 :commodityId="form.commodityId" @changeStep="changeStep"></step3>
      </template>
     
    </el-main>
  </el-container>
</template>

<script>
  import Base64 from '@/api/video/lib/base64.js';
  import alioss from '@/api/video/ali-oss.js';
  import AliyunUpload from 'aliyun-upload-vod';
  import Crypto from 'crypto-js';
  import OSS from 'ali-oss';
  import validate from '@/api/validate.js';
  import DndList from '@/components/DndList';
  import { lineHeightStyle } from '@/api/lineHeight.js';
  import Quill from 'quill';
  import ckeditor from '@/components/ckeditor/ckeditor.vue';
  import draggable from 'vuedraggable';
  import combinationCommodity from './CombinationCommodity';
  import commodityModel from './commodityModel';
  import FileUpload from '@/components/FileUpload/FileUpload.vue';
  import choseCommodity from './choseCommodity';
  import step3 from './step3';
  import AliPlayer from '@/components/AliPlayer/AliPlayer.vue';
  import {dateFormat} from '@/api/utils.js';
  const toolbarOptions = [
    ['bold', 'italic', 'underline', 'strike'],        // toggled buttons
    [{'header': 1}, {'header': 2}],               // custom button values
    [{'list': 'ordered'}, {'list': 'bullet'}],
    [{'indent': '-1'}, {'indent': '+1'}],          // outdent/indent
    [{'direction': 'rtl'}],                         // text direction
    [{'size': ['small', false, 'large', 'huge']}],  // custom dropdown
    [{'header': [1, 2, 3, 4, 5, 6, false]}],
    [{'color': []}, {'background': []}],          // dropdown with defaults from theme
    [{'font': []}],
    [{'align': []}],
    ['link', 'image'],
    ['clean'],
    ['code-block'],
    [{ lineheight: ['initial', '1', '1.5', '1.75', '2', '3', '4', '5'] }]

  ];
  var duration;
  export default {
    components: { DndList,ckeditor,draggable,combinationCommodity, commodityModel, FileUpload,choseCommodity,step3,"ali-player": AliPlayer,dateFormat},
    data() {
      var validPeriod = (rule, value, callback) => {
        const reg = /^\d{1,4}$/;
        if(this.form.validityType == 1) {
          callback();
        } else if (value === '' || value < 0) {
          callback(new Error('有效期不能为0,负数或者空'));
        } else if(!reg.test(value)) {
          callback(new Error('只允许输入1-9999的正整数'));
        } else {
          callback();
        }
      };
      return {
        myHeaders: {
          Authentication: localStorage.getItem("token")
          // Authorization
        },
        reFresh: true,
        startTimeHoursRule:'00:00:00 - 23:59:59',
        endTimeHoursRule:'00:00:00 - 23:59:59',
        startTime: {
          disabledDate: time => {
            if (this.form.preferentialEndTime) {
              return (
                  time.getTime() >= new Date(this.form.preferentialEndTime).getTime()
              );
            }
          }
        },
        endTime: {
          disabledDate: time => {
            if (this.form.preferentialBeginTime) {
              return (
              time.getTime() <= new Date(this.form.preferentialBeginTime).getTime() - 1 * 24 * 60 * 60 * 1000
              );
            }
          }
        },
        modelTypeListDataMain: [],
        modelTypeListMain: [],
        spanArr: {},
        choseCommodityIds: [],
        choseCommodity: false,
        skuCombinedPriceVoList: [],
        orgType: '',
        orgCode: '',
        pageTitle:'添加商品',
        addCourse: false,
        preferentialTime: 'preferentialEndTime',
        rules: {
          courseName: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            {max: 200, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          courseEnglishName: [
            {required: true, message: '请输入课程名称', trigger: 'blur'},
            {max: 200, message: '长度不得超过50个字符', trigger: 'blur'}
          ],
          courseRussianName: [
            {required: true, message: '请输入俄语课程名称', trigger: 'blur'}
          ],
          courseSpanishName: [
            {required: true, message: '请输入西班牙语课程名称', trigger: 'blur'}
          ],          
          ccId:[
            {required: true, message: '请选择主营类目', trigger: 'blur'}
          ],
          blur: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          orgCcId: [
            {required: true, message: '请选择分类', trigger: 'blur'}
          ],
          introduce: [
            {required: true, message: '请输入特色介绍', trigger: 'blur'},
            {max: 30, message: '长度不得超过30个字符', trigger: 'blur'}
          ],
          englishIntroduce: [
            {required: true, message: '请输入特色介绍', trigger: 'blur'},
            {max: 200, message: '长度不得超过100个字符', trigger: 'blur'}
          ],
          russianIntroduce: [
            {required: true, message: '请输入俄语特色介绍', trigger: 'blur'}
          ],
          spanishIntroduce: [
            {required: true, message: '请输入西班牙语特色介绍', trigger: 'blur'}
          ],                    
          price: [
            {required: true, message: '请输入价格', trigger: 'blur'},
            {validator: validate.validatePrice, trigger: 'blur'}
          ],
          standard: [
            {required: true, message: '请输入课时标准', trigger: 'blur'},
            {validator: validate.validatePreferentialPrice, trigger: 'blur'}
          ],
          persionNum: [
            {required: true, message: '请输入人数', trigger: 'blur'},
            {validator: validate.validateNumber, trigger: 'blur'}
          ],
          classTime: [
            {validator: validate.validateClassTime, trigger: 'blur'}
          ],
          validity: [
            {validator: validPeriod, trigger: 'change'}
          ],
          openClassTime: [
            {required: true, message: '请选择开班日期', trigger: 'blur'}
          ],
          lessonType: [
            {required: true, message: '请选择授课类型', trigger: 'blur'}
          ],
          orgCode: [
            {required: true, message: '请选择所属机构', trigger: 'blur'}
          ],
          picturePath: [
            {required: true, message: '请上传课程封面', trigger: 'change'}
          ],
          isView: [
            {required: true, message: '请选择是否显示', trigger: 'blur'}
          ],
          isPacking: [
            {required: true, message: '请选择是否打包', trigger: 'blur'}
          ],
          courseId: [
            {required: true, message: '请选择关联课程', trigger: 'blur'}
          ],
          contactInfo: [
            {max: 200, message: '长度不得超过100个字符', trigger: 'blur'}
          ],
          sort: [
            {validator: validate.validateSort, trigger: 'blur'}
          ],
          courseType:[
            {required: true, message: '请选择课程分类', trigger: 'blur'}
          ],
          preferentialEndTime:[
          ],
          preferentialBeginTime: [
          ]
        },
        autoIsUpload: false,
        uploadMethodData: '1',
        uploadMethodDataType: '1',
        dialogAuditionVideo: false,
        videoSrc: '',
        videoType: '',// 1: 阿里h5 0: 其他
        loaded: false,
        vid: '',
        playAuth: '',
        encryptType: 1,
        videoPath: '',
        pathName: '',
        filePicture:'',
        auditionUpload:'',
        form: {
          auditionVideoStrList: [],
          commodityId: '',
          courseName: '',
          ccId: '',
          orgCcId: '',
          ccPId: '',
          price: '',
          validity: '',
          validityType: 1,
          specType: 0,
          videoImageUrl: '',
          skuSpecVoList: [],
          skuPriceVoList: [],
          introduce: '',
          modelType: 1,
          preferential: '',
          preferentialBeginTime: null,
          preferentialEndTime: null,
          persionNum: '',
          classTime: '',
          openClassType: 1,
          openClassTime: dateFormat(new Date()),
          lessonType: 1,
          commodityLecturerList: [],
          lecturers: [],
          lecturer: [],
          auditionVideoPath: '',
          auditionVideoPathView: '',
          auditionVideoVo: {},
          picturePath: '',
          picturePathView: '',
          courseIntroduce: '',
          courseId: '',
          courseView: '',
          orgCode: '',
          contactInfo: '',
          autoMessage: [],
          standard: '',
          sort: '',
          orgSort: '',
          isView: 1,
          isPacking: 0,
          courseType: 0,
          similarCommodityRecommendList: [],
          combinedCommodityList: [],
          skuCombinedPriceVoList: []
        },
        options: {
          img: '',                         //裁剪图片的地址
          info: true,                      //裁剪框的大小信息
          outputSize: 1,                   // 裁剪生成图片的质量
          outputType: 'jpeg',              //裁剪生成图片的格式
          canScale: false,                 // 图片是否允许滚轮缩放
          autoCrop: true,                  // 是否默认生成截图框
          autoCropWidth: 160,              // 默认生成截图框宽度
          autoCropHeight: 90,             // 默认生成截图框高度
          fixed: false,                    //是否开启截图框宽高固定比例
          fixedNumber: [16, 9]              //截图框的宽高比例
        },
        isShowCropper: false,
        fileinfo: {},
        org: [],
        courseName: '',
        courseId: '',
        step: 1,
        courseData: [],
        courseChild: [],
        courseChildData: {},
        uploadURL: '',
        uploadURLP:'',
        hidePictureUpload: false,
        hideAuditionVideoUpload: false,
        pictureLimitCount: 1,
        auditionVideoLimitCount: 1,
        pictureFileList: [],
        imageFileList: [],
        auditionUploadfileList:[],
        auditionVideoFileList: [],
        dialogVisible: false,
        dialogImageUrl: '',
        teacherList: [],
        teacherData: [],
        teacherData1: [],
        loading: false,
        quillUpdateImg: false,
        courseList: [],
        disableCourse: false,
        video: {
          videoInfoId: '',
          videoInfoName: '',
          duration: '',
          bak2: ''
        },
        src: 'https://live.eblcu.cn/',
        version: 'player.v2.swf',
        _parm: '',
        isAutoStart: 'true',
        isOldAddress: 'true',
        isRtmp: false,
        rtmpParam: {
          data: '',
          movie: ''
        },
        auditionVideoStrListTemp: [],
        position: 0,
        percent: 0,
        categoryOptions: [],
        courseOptions: [],
        selectedCourse: [],
        selectedCategory: [],
        selectedOrgCategory: [],
        categoryOptionsMap: {},
        categoryOrgOptions: [],
        categoryOrgOptionsMap: {},
        showOrgCC: false,
        value1: '',
        value2: '',
        choseCommoditys: [],
        similarCommodityTempList: [],
        skuCombinedPriceVoTempList: [],
        skuPriceVoListTemp: [],
        loginOrgCode: '',
        glSearchData: {
          size: 0,
          page: 1,
          courseName: '',
          ccId: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          orgCode: '',
          isView: 1,
          excludeId: ''
        },
        searchData: {
          size: 0,
          page: 1,
          courseName: '',
          ccId: '',
          selectedOption: [],
          commodityStatus: '',
          lessonType: '',
          pccId: '',
          courseType: '0',
          orgCode: '',
          specType: 0,
          excludeId: ""
        },
        excludeId: '',
        commodityTags: [],
        uploader: null,
        editorOption: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    document.querySelector('.avatar-uploader input').click();
                  } else {
                    this.quill.format('image', false);
                  }
                },
                lineheight: function (value) {
                  if (value) {
                    this.quill.format('lineHeight', value);
                  } else {
                    console.log(value);
                  }
                }
              }
            }
          }
        },
        // 型号相关
        modelTypeList: [],
        modelTypeListData: [],
        typeTagShow: false,
        commodityList: [],
        editorOptionEnglish: {
          placeholder: '',
          theme: 'snow',  // or 'bubble'
          modules: {
            toolbar: {
              container: toolbarOptions,
              handlers: {
                'image': function(value) {
                  if (value) {
                    document.querySelector('.avatar-uploaderEnglish input').click();
                  } else {
                    this.quill.format('image', false);
                  }
                },
                lineheight: function (value) {
                  if (value) {
                    this.quill.format('lineHeight', value);
                  } else {
                    console.log(value);
                  }
                }
              }
            }
          }
        }
      };
    },
    methods: {
      HandleauditionUploadSuccess(response) {
        console.log(response.code,'response.code');
        this.auditionUploadfileList = [];
        if(response.code == 200) {
          this.pathName = response.data.fileName;
          this.videoPath = response.data.resourceUrl;
          let file = {
          name: response.data.fileName,
          url: response.data.resourceUrl
          };
          this.auditionUploadfileList.push(file);
          this.options.img = file.url;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
      },
      handleauditionUploadRemove(file, fileList) {
        console.log(file, fileList);
      },
      handleauditionUploadPreview(file) {
        console.log(file);
      },
      handleauditionUploadExceed(files, fileList) {
        this.$message.warning(`当前限制选择 3 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`);
      },
      beforeauditionUploadRemove(file, fileList) {
        return this.$confirm(`确定移除 ${ file.name }？`);
      },
  
      ajax(url,data,fn){
        const xhr =new XMLHttpRequest();
        xhr.onreadystatechange =function(){
          if(xhr.readyState ===4 && xhr.status ===200){
            fn(xhr.responseText);
          }
        }
        const formData=new FormData();
        formData.append('upfile',data);
        xhr.open("post",url,true);
        xhr.setRequestHeader("Authentication",localStorage.getItem("token"));
        xhr.send(formData);
      },

      changeStep(type, val) {
        if(type == 'next') {
          this.step = this.step + 1;
        }
        if(type == 'prev') {
          this.step = this.step - 1;
        }
      },
      changeCommodityList(commoditys) {
        this.choseCommoditys = commoditys;
        let similarCommodityRecommendList = [];
        for(let commodity of this.choseCommoditys) {
          let similarCommodity = {};
          similarCommodity.recommendId = commodity.commodityId;
          similarCommodity.recommendName = commodity.courseName;
          similarCommodityRecommendList.push(similarCommodity);
        }
        this.form.similarCommodityRecommendList = similarCommodityRecommendList;
      },
      ready() {
        Quill.register({ 'formats/lineHeight': lineHeightStyle }, true);
      },
      handleDialogClose() {
        this.addCourse = false;
      },
      objectSpanMethod(item) {
        let row = item.row;
        let column = item.column;
        let field = column.property;
        let rowIndex = item.rowIndex;
        let columnIndex = item.columnIndex;
        if(this.spanArr[field]) {
          const _row = this.spanArr[field][rowIndex];
          return {
            rowspan: _row,
            colspan: 1
          };
        }

      },
      reUpload() {
        // this.auditionVideoHandleRemove();
        this.imageFileList = [];
        this.form.auditionVideoVo
        this.videoSrc = '';
        this.videoPath = this.form.auditionVideoVo.filePath;
        this.pathName = this.form.auditionVideoVo.fileName;
        this.filePicture = this.form.auditionVideoVo.filePicture;
        let file = {
          name: this.form.auditionVideoVo.fileName,
          url: this.form.auditionVideoVo.filePicture
        };
        this.imageFileList.push(file);
        this.uploadMethodDataType = 1;
      },
      parm(url, mediaURL) {
        this._parm = '?';
        this._parm += 'url=' + url + '&&';
        this._parm += 'filename=' + mediaURL + '&&';
        this._parm += 'isAutoStart=' + this.isAutoStart + '&&';
        this._parm += 'isOldAddress=' + this.isOldAddress + '&&';
      },
      
      selectPlayer() {
        let url = this.videoSrc;
        this.isRtmp = false;
        if(!url) {
          return;
        }
        if (url.indexOf('rtmp:') >= 0) {
          this.isRtmp = true;
          let urls = url.split('/mp4:');
          let url1 = urls[0];
          let mediaURL = urls[1];
          this.parm(url1, mediaURL);
          // data this.src+this.getVersion()+this.parm()
          this.rtmpParam.data = this.src + this.version + this._parm;
          this.rtmpParam.movie = this.src + this.version + this._parm;
        }
      },
      
      showVideo() {
        if (this.videoSrc == '') {
          this.$message({
            type: 'info',
            message: '视频未上传！'
          });
          return;
        }
        this.selectPlayer();
        this.dialogAuditionVideo = true;
      },
      confirmUpload() {
        if (this.videoPath == '') {
          this.$message({
            type: 'info',
            message: '视频链接不能为空！'
          });
          return;
        }
        // var obj=this.$refs.box;//获取元素的dom
        // var file = obj.files[0];  
        // console.log(file,'file');  

        let params = {
          pathName: this.pathName,
          path: this.videoPath,
          filePicture:this.filePicture
        }; 
        console.log(params.filePicture,'111111ly');
        this.https.fetchPost('/file/upload_path', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          console.log(data,'datadatadatadata');
          if (code == 200) {
            this.form.auditionVideoVo ={fileName: this.pathName ,fileId: data.data.data.fileId} ;
            this.videoSrc = this.videoPath;
            this.uploadMethodDataType = 2;
            this.selectPlayer();
            this.$message({
              type: 'success',
              message: '上传成功'
            });
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );

      },
      uploadMethod(val) {
        console.log(val,'valvalvalvalvalvalvalvalval');
        this.uploadMethodData = val;
      },
      clickFile() {
        document.querySelector('.avatar-uploader input').click();
      },
      clickFile() {
        document.querySelector('.avatar-uploaderEnglish input').click();
      },
      submitUpload() {
        let uploadFiles = this.$refs.auditionVideo.uploadFiles;
        if (uploadFiles.length != 1) {
          this.$message({
            type: 'info',
            message: '只能上传一个试听视频'
          });
          return;
        }

        let file = uploadFiles[0].raw;
        let extendName = file.name.substr(file.name.lastIndexOf('.') + 1);
        let videoName = file.name.substr(0, file.name.lastIndexOf('.'));
        let fileSize = file.size;
        let params = {
          extendName: extendName,
          videoName: videoName
        };
        this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.video.videoInfoId = data.data.data.videoInfoId;
            this.video.videoInfoName = data.data.data.videoName+"."+extendName;
            this.video.bak2 = fileSize;
            this.uposs(data.data.data, file);
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              this.$message.error('网络错误');
              console.log(err);
            }
        );
      },
      changeDate() {
      },
      handlePictureCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleImageCardPreview(file) {
        this.dialogImageUrl = file.url;
        this.dialogVisible = true;
      },
      handleAutoCardPreview() {

      },
      auditionVideoHandleRemove(file, fileList) {
        this.form.auditionVideoVo = {};
        this.$refs.auditionVideo.clearFiles;
        this.auditionVideoFileList = [];
        this.percent = 0;
        this.autoIsUpload = false;
        //this.hideAuditionVideoUpload = fileList.length >= this.auditionVideoLimitCount;
      },
      auditionVideoOnChange(file, fileList) {
        let fileName = file.name;
        let extendName = fileName.substr(file.name.lastIndexOf('.') + 1);
        let videoName = fileName.substr(0, file.name.lastIndexOf('.'));
        if (extendName == 'mp4') {
          if (!this.autoIsUpload) {
            this.autoIsUpload = true;
            
            if(this.loginOrgCode == 'blcuonline') {
              if (this.uploader) {
                this.uploader.stopUpload()
              }
              let userData = '{"Vod":{}}';
              this.uploader = this.createUploader();
              console.log(userData);
              this.uploader.addFile(file.raw, null, null, null, userData);
              if (this.uploader !== null) {
                this.uploader.startUpload()
              }
            } else {
              this.submitUpload();
            }
          }
        } else {
          this.$message({
            type: 'info',
            message: '只能上传mp4格式视频！'
          });
          this.$refs.auditionVideo.clearFiles;
          this.auditionVideoFileList = [];
        }

      },
      auditionVideoHandleSuccess(response) {
        this.auditionVideoFileList = [];
        this.form.auditionVideoPath = response.data.fileId;
        this.form.auditionVideoVo = {fileId: response.data.fileId}
        let file = {
          name: '123.png',
          url: response.data.filePath
        };
        this.auditionVideoFileList.push(file);

      },

      createUploader (type) {
        let self = this
        let uploader = new AliyunUpload.Vod({
          timeout:  60000,
          partSize:  1048576,
          parallel:  5,
          retryCount:  3,
          retryDuration:  2,
          region: 'cn-shanghai',
          userId: '10193998',
          // 添加文件成功
          addFileSuccess: function (uploadInfo) {
            console.log("addFileSuccess: " + uploadInfo.file.name)
          },
          // 开始上传
          onUploadstarted: function (uploadInfo) {
            // 如果是 UploadAuth 上传方式, 需要调用 uploader.setUploadAuthAndAddress 方法
            // 如果是 UploadAuth 上传方式, 需要根据 uploadInfo.videoId是否有值，调用点播的不同接口获取uploadauth和uploadAddress
            // 如果 uploadInfo.videoId 有值，调用刷新视频上传凭证接口，否则调用创建视频上传凭证接口
            // 注意: 这里是测试 demo 所以直接调用了获取 UploadAuth 的测试接口, 用户在使用时需要判断 uploadInfo.videoId 存在与否从而调用 openApi
            // 如果 uploadInfo.videoId 存在, 调用 刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)
            // 如果 uploadInfo.videoId 不存在,调用 获取视频上传地址和凭证接口(https://help.aliyun.com/document_detail/55407.html)
              let createUrl = '/videoInfo/getAliAuthorization';
              console.log(uploadInfo);
              let params = {
                videoFullName: uploadInfo.file.name,
                videoName: uploadInfo.file.name,
                type: 1
              };
              self.https.fetchPost('/videoInfo/getAliAuthorization', params, 'json').then((data) => {
                let code = data.data.code;
                let msg = data.data.msg;
                if (code == 200) {
                  let response = data.data.data.response;
                  let uploadAuth = response.uploadAuth
                  let uploadAddress = response.uploadAddress
                  let videoId = response.videoId
                  uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId);
                } else {
                  this.$message({
                    type: 'info',
                    message: '上传失败:' + msg
                  });
                }
              }).catch(err => {
                    console.log(err);
                  }
              );
              console.log("onUploadStarted:" + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            /*else {
              // 如果videoId有值，根据videoId刷新上传凭证
              // https://help.aliyun.com/document_detail/55408.html?spm=a2c4g.11186623.6.630.BoYYcY
              let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
              axios.get(refreshUrl).then(({data}) => {
                let uploadAuth = data.UploadAuth
                let uploadAddress = data.UploadAddress
                let videoId = data.VideoId
                uploader.setUploadAuthAndAddress(uploadInfo, uploadAuth, uploadAddress,videoId)
              })
            }*/
          },
          // 文件上传成功
          onUploadSucceed: function (uploadInfo) {
            console.log("onUploadSucceed: " + uploadInfo.file.name + ", endpoint:" + uploadInfo.endpoint + ", bucket:" + uploadInfo.bucket + ", object:" + uploadInfo.object)
            let params = {
              videoId:uploadInfo.videoId
            };
            self.https.fetchPost('/videoInfo/submitTranscodeJob', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                let fileId = data.data.data.fileId;
                let videoInfoId = data.data.data.videoInfoId;
                self.form.auditionVideoPath = videoInfoId;
                self.form.auditionVideoVo = {fileId: videoInfoId,fileName: uploadInfo.file.name}
                self.videoType=1;
                self.uploadMethodDataType = 2;
              } else {
                this.$message({
                  type: 'info',
                  message: '上传失败:' + msg
                });
              }
            }).catch(err => {
                  console.log(err);
                }
            );
          },
          // 文件上传失败
          onUploadFailed: function (uploadInfo, code, message) {
            console.log("onUploadFailed: file:" + uploadInfo.file.name + ",code:" + code + ", message:" + message)
          },
          // 取消文件上传
          onUploadCanceled: function (uploadInfo, code, message) {
            console.log("Canceled file: " + uploadInfo.file.name + ", code: " + code + ", message:" + message)
          },
          // 文件上传进度，单位：字节, 可以在这个函数中拿到上传进度并显示在页面上
          onUploadProgress: function (uploadInfo, totalSize, progress) {
            console.log("onUploadProgress:file:" + uploadInfo.file.name + ", fileSize:" + totalSize + ", percent:" + Math.ceil(progress * 100) + "%")
            let progressPercent = Math.ceil(progress * 100)
            self.percent = progressPercent
          },
          // 上传凭证超时
          onUploadTokenExpired: function (uploadInfo) {
            // 上传大文件超时, 如果是上传方式一即根据 UploadAuth 上传时
            // 需要根据 uploadInfo.videoId 调用刷新视频上传凭证接口(https://help.aliyun.com/document_detail/55408.html)重新获取 UploadAuth
            // 然后调用 resumeUploadWithAuth 方法, 这里是测试接口, 所以我直接获取了 UploadAuth
            let refreshUrl = 'https://demo-vod.cn-shanghai.aliyuncs.com/voddemo/RefreshUploadVideo?BusinessType=vodai&TerminalType=pc&DeviceModel=iPhone9,2&UUID=59ECA-4193-4695-94DD-7E1247288&AppVersion=1.0.0&Title=haha1&FileName=xxx.mp4&VideoId=' + uploadInfo.videoId
            axios.get(refreshUrl).then(({data}) => {
              let uploadAuth = data.UploadAuth
              uploader.resumeUploadWithAuth(uploadAuth)
              console.log('upload expired and resume upload with uploadauth ' + uploadAuth)
            })
          },
          // 全部文件上传结束
          onUploadEnd: function (uploadInfo) {
            console.log("onUploadEnd: uploaded all the files");
          }
        })
        return uploader
      },
      getAliUrl(videoInfoId) {
        let params = {
          videoInfoId:videoInfoId
        };
        this.https.fetchPost('/videoInfo/getVODPlayAuth', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let playAuth = data.data.data.playAuth;
            let videoId = data.data.data.videoMeta.videoId;
            this.playAuth = playAuth;
            this.vid = videoId;
            this.loaded = true;
          } else if(code == 300){
            this.transcoded = true;
          } else {
            this.$message({
              type: 'info',
              message: '上传失败:' + msg
            });
          }
        }).catch(err => {
              console.log(err);
            }
        );
      },
      auditionVideoBeforeAvatarUpload(file) {
        let params = {
          extendName: 'mp4',
          videoName: '123'
        };
        if(this.loginOrgCode == 'blcuonline') {
          if (this.uploader) {
            this.uploader.stopUpload()
          }
          let userData = '{"Vod":{}}';
          this.uploader = this.createUploader();
          console.log(userData);
          this.uploader.addFile(this.file, null, null, null, userData);
          /*if (this.uploader !== null) {
            this.uploader.startUpload()
          }*/
        } else {
          this.https.fetchPost('/file/getAuthorization', params, 'json').then((data) => {
            let code = data.data.code;
            if (code == 200) {
              this.video.videoInfoId = data.data.data.videoInfoId;
              this.uposs(data.data.data, file);
            } else {
              this.$message({
                type: 'info',
                message: '加载失败:' + msg
              });
            }

          }).catch(err => {
                this.$message.error('网络错误');
                console.log(err);
              }
          );
        }
       
        return false;
      },
      multiSuccess(result) {
        if (result) {
          if (result.res.status == 200) {
            let params = {
              videoInfoId: this.video.videoInfoId,
              videoInfoName: this.video.videoInfoName,
              bak2: this.video.bak2,
              duration: parseInt(this.video.duration)
            };
            this.https.fetchPost('/file/saveVideoPlayUrl', params, 'json').then((data) => {
              let code = data.data.code;
              let msg = data.data.msg;
              if (code == 200) {
                this.videoSrc = data.data.data.url;
                this.form.auditionVideoPath = data.data.data.videoInfoId;
                this.form.auditionVideoVo = {fileId: data.data.data.videoInfoId,fileName: this.video.videoInfoName}
                this.selectPlayer();
                this.uploadMethodDataType = 2;
              } else {
                this.$message({
                  type: 'info',
                  message: '加载失败:' + msg
                });
              }

            }).catch(err => {
                  this.$message.error('网络错误');
                  console.log(err);
                }
            );
          }
        }
      },
      multiError() { //上传失败
        console.log('上传失败,请重新上传', 'error');
      },
      videoDuration(ele) {
        let duration = document.getElementById('aa').duration;
        if(duration == null) {
          duration = 0;
        }
        this.video.duration = duration;
      },
      uposs(obj, file) {
        var accesskey = obj.accesskeysecret;
        let key = obj.keyWord;
        var accessKeyId = obj.accesskeyid;
        var stsToken = obj.securitytoken;
        var videoInfoId = obj.videoInfoId;
        var urlfile = URL.createObjectURL(file);
        document.getElementById('aa').src = urlfile;
        var policyText = {
          'expiration': '2020-01-01T12:00:00.000Z', //设置该Policy的失效时间，超过这个失效时间之后，就没有办法通过这个policy上传文件了
          'conditions': [
            ['content-length-range', 0, 10485760000] // 设置上传文件的大小限制
          ]
        };

        var policyBase64 = Base64.Base64.encode(JSON.stringify(policyText));
        var message = policyBase64;
        var bytes = Crypto.HmacSHA1(message, accesskey);
        let signature = bytes.toString(Crypto.enc.Base64);


        let ossClient = new OSS({
          'region': 'oss-cn-beijing',
          'accessKeyId': accessKeyId, //1111
          'accessKeySecret': accesskey,
          'stsToken': stsToken, //1111
          'bucket': 'openbj',
          'endpoint': 'https://oss-cn-beijing.aliyuncs.com',
          'policy': policyBase64,
          'success_action_status': '200', //让服务端返回200,不然，默认会返回204
          'signature': signature
        });

        let abort = false; //进度条显示
        let checkpoint_temp = true;
        let result = alioss.multitest(ossClient, file, checkpoint_temp, this.multiSuccess, '', this.uploadProgress, key);

      },
      uploadProgress(percent) {
        this.percent = percent * 100;
      },

      pictureHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      imageHandleRemove(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      imageOnChange(file, fileList) {
        this.hidePictureUpload = fileList.length >= this.pictureLimitCount;
      },
      pictureHandleSuccess(response, file, fileList) {
        this.pictureFileList = [];
        if(response.code == 200) {
          this.form.picturePath = response.data.fileId;
          let file = {
            name: response.data.filePath,
            url: response.data.filePath
          };
          this.pictureFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      imageHandleSuccess(response, file, fileList) {
        this.imageFileList = [];
        if(response.code == 200) {
          console.log(response,'responseresponse');
          this.filePicture = response.data.filePath;
          let file = {
            name: response.data.filePath,
            url: response.data.filePath
          };
          this.imageFileList.push(file);
          this.options.img = file.url;
          this.isShowCropper = true;
          this.hidePictureUpload = true;
        } else {
          this.$message.error('上传图片失败!');
          this.hidePictureUpload = false;
        }
        
      },
      pictureBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });
        return isJPG && isLt2M && isSize;
      },
      imageBeforeAvatarUpload(file) {
        const isJPG = file.type === 'image/jpeg' || file.type === 'image/png' || file.type === 'image/bmp';
        const isLt2M = file.size / 1024 / 1024 < 20;
        if (!isJPG) {
          this.$message.error('上传图片只能是 JPG/PNG/BMP 格式!');
        }
        if (!isLt2M) {
          this.$message.error('上传图片大小不能超过 2MB!');
        }
        const isSize = new Promise(function(resolve, reject) {
          let width = 750;
          let height = 388;
          let _URL = window.URL || window.webkitURL;
          let img = new Image();
          img.onload = function() {
            let valid = img.width/img.height == 16/9;
            valid ? resolve() : reject();
          };
          img.src = _URL.createObjectURL(file);
        }).then(() => {
          return file;
        }, () => {
          this.$message.error('上传图片尺寸必须为16:9!');
          return Promise.reject();
        });
        return isJPG && isLt2M && isSize;
      },
      onCubeImg() {
        // 获取cropper的截图的base64 数据
        this.$refs.cropper.getCropData(data => {
          console.log(data);
          this.fileinfo.url = data;
          this.isShowCropper = false;

          //先将显示图片地址清空，防止重复显示
          this.option.img = '';

          //将剪裁后base64的图片转化为file格式
          let file = this.convertBase64UrlToBlob(data);
        });
      },
      convertBase64UrlToBlob(urlData) {
        let bytes = window.atob(urlData.split(',')[1]);//去掉url的头，并转换为byte
        //处理异常,将ascii码小于0的转换为大于0
        let ab = new ArrayBuffer(bytes.length);
        let ia = new Uint8Array(ab);
        for (var i = 0; i < bytes.length; i++) {
          ia[i] = bytes.charCodeAt(i);
        }
        return new Blob([ab], {type: 'image/jpeg'});
      },
      goBack() {
        this.$router.go(-1);
      },
      prev() {
        this.step = this.step - 1;
        if (this.form.validityType == 1) {
          this.form.validity = '';
        }
        if(this.step == 1) {
          this.commodityList = [];
          let temp = JSON.parse(JSON.stringify(this.form.similarCommodityRecommendList));
          let tempAudio = JSON.parse(JSON.stringify(this.form.auditionVideoStrList));
          this.form.similarCommodityRecommendList = [];
          this.form.auditionVideoStrList = [];
          this.$nextTick(_ => {
            this.initCombinedCommodityList(this.form.combinedCommodityList);
            this.form.similarCommodityRecommendList = JSON.parse(JSON.stringify(temp));
            this.form.auditionVideoStrList = JSON.parse(JSON.stringify(tempAudio));
          });
          
        }
      },
      
      changeChildrenCourse(val) {
        this.searchCourse(val);
      },
      changeOpenClass(val) {
        if (val == 1) {
          
          this.form.openClassTime = dateFormat(new Date());
        } else {
          this.form.openClassType = 2;
        }
      },
      changeValidityType(val) {
        if(val == 1) {
          this.form.validity = '';
          this.form.validityType=1;
          this.$refs.courseForm.clearValidate('validity');
        } else {
          this.form.validityType=2;
          this.form.validity = '';
        }

      },
      saveAndNext(val) {
        let params = this.form;
        console.log(params,'paramsparamsparams');
        console.log(this.form.auditionVideoStrList,'this.form.auditionVideoStrList');
        if(this.form.specType == 1) {
          this.makeModelTypeListData();
          this.form.skuSpecVoList = this.modelTypeList;
          if(this.form.combinedCommodityList.length>0  && this.form.skuCombinedPriceVoList.length ==0) {
            skuCombinedFlag = true;
          }
          for(let skuCombined of this.form.skuCombinedPriceVoList) {
            if(!skuCombined.price || skuCombined.price == '') {
              skuCombinedFlag = true;
            }
          }

        }
        
        if(this.form.preferentialBeginTime || this.form.preferentialEndTime) {
          if(!this.form.preferentialBeginTime) {
            this.$message.error('优惠开始时间不能为空！');
            return;
          }
          if(!this.form.preferentialEndTime) {
            this.$message.error('优惠截止时间不能为空！');
            return;
          }
          if(new Date(this.form.preferentialBeginTime).getTime() >= new Date(this.form.preferentialEndTime).getTime()) {
            this.$message.error('优惠开始时间不能大于截止时间！');
            return;
          }
          if(this.form.specType == 1) {
            for(let priceList of this.form.skuPriceVoList) {
              if(priceList.preferentialPrice === '' || priceList.preferentialPrice === 0) {
                this.$message.error('选定优惠时间后，优惠价不能为空或者0！');
                return;
              }
            }
          }
        }
        let flagPrice = false;
        let modelTypeFlag = false;
        let skuCombinedFlag = false;
        if(this.form.specType == 0) {
          if(this.form.combinedCommodityList.length>0 && this.form.skuCombinedPriceVoList.length ==0) {
            skuCombinedFlag = true;
          }
          for(let skuCombined of this.form.skuCombinedPriceVoList) {
            if(skuCombined.price == '') {
              skuCombinedFlag = true;
            }
          }
          if(this.form.combinedCommodityList.length > this.form.skuCombinedPriceVoList.length) {
            skuCombinedFlag = true;
          }
        }
        
        if(skuCombinedFlag) {
          this.$message.error('组合价格不能为空！');
          return;
        }
        if(this.form.specType == 1) {
          for(let priceList of this.form.skuPriceVoList) {
            if(priceList.price === '') {
              flagPrice = true;
            }
          }
          for(let modelType of this.modelTypeListMain) {
            if(modelType.specName == '') {
              modelTypeFlag = true;
            }
          }
        }
        
        if(modelTypeFlag) {
          this.$message.error('型号分类不能为空！');
          return;
        }
        if(flagPrice) {
          this.$message.error('原价不能为空！');
          return;
        }
        let lecturers = JSON.parse(JSON.stringify(this.form.lecturer));
        let lecturer = [];
        for (let i in lecturers) {
          let l = {
            lecturer: lecturers[i]
          };
          lecturer.push(l);
        }
        let flag = true;
        if(this.selectedCategory instanceof Array) {
          if(this.selectedCategory.length > 0) {
            this.form.ccId = this.selectedCategory[this.selectedCategory.length-1];
          }
        } else {
          this.form.ccId = this.selectedCategory;
        }
        if(this.selectedOrgCategory.length > 0) {
          this.form.orgCcId = this.selectedOrgCategory[this.selectedOrgCategory.length-1];
        }
        if(this.loginOrgCode == 'blcuonline') {
          this.form.ccId = this.form.orgCcId;
        }
        this.form.commodityLecturerList = lecturer;
        let url = '/commodityInfo/saveCommodity';
        if (val == 1) {
          this.$refs['courseForm'].validate((valid) => {
            if (!valid) {
              this.$message.error('请正确填写信息！');
              flag = false;
            }
          });
          if (this.form.validityType == 1) {
            this.form.validity = -1;
          }
          else if(this.form.validity==''){
            this.$message.error('请输入有效期');
            flag = false;
          }
          if (this.form.openClassType == 1) {
            this.form.openClassTime ='1970-01-01 00:00:00';
          }
        }
        if (val == 2) {
          url = '/commodityInfo/updateCourseIntroduceByCommodityId';
          if (!this.form.courseIntroduce) {
            this.$message.error('请填写课程简介');
            flag = false;
          }
          this.searchCourseType();
        }
        if (val == 3) {
          url = '/commodityInfo/updateCourseIdByCommodityId';
          // if (!this.form.courseId) {
          //   this.$message.error('请选择关联课程');
          //   flag = false;
          // }
        }
        if (flag) {
          console.log("提交参数：",params);
          this.https.fetchPost(url, params, 'json').then((data) => {
            let code = data.data.code;
            let msg = data.data.msg;
            if (code == 200) {
              this.$message({
                message: '操作成功',
                type: 'success'
              });
              if (val == 3) {
                this.$router.push({path: 'commodity'});
              }
              if (val == 1) {
                if (!this.form.commodityId) {
                  this.form.commodityId = data.data.data;
                }
              }
              if (val == 2) {
                this.searchCourse();
              }
              if (val != 3) {
                this.step = this.step + 1;
              }

            } else {
              this.$message({
                type: 'info',
                message: msg
              });
            }

          }).catch(err => {
                console.log(err);
                this.$message.error('网络错误');
              }
          );

        }

      },
      exceed(res, file) {
        console.log(res);
      },
      onError () {
      },
      onEditorChange({editor, html, text}) {

      },
      uploadSuccess(res, file) {
        let quill = this.$refs.myQuillEditor.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, 'image', res.data.filePath);
        quill.setSelection(length + 1);
        this.quillUpdateImg = false;
      },
      uploadEnglishSuccess(res, file) {
        let quill = this.$refs.myQuillEditorEnglish.quill;
        let length = quill.getSelection().index;
        quill.insertEmbed(length, 'image', res.data.filePath);
        quill.setSelection(length + 1);
        this.quillUpdateImg = false;
      },
      
      uploadError() {
        this.quillUpdateImg = false;
        this.$message.error('图片插入失败');
      },
      beforeUpload() {
        this.quillUpdateImg = true;
      },
      beforeEnglishUpload() {
        this.quillUpdateImg = true;
      },
      
      //加载本部分类
      loadCourseCategory() {
        let params = {
          orgCode: this.$store.state.eblcuOrg
        };
        if(this.loginOrgCode == 'blcuonline') {
          params.orgCode = 'blcuonline'
        }
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.categoryOptions = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      
      selectCategoryData(val) {
        if(val == this.$store.state.eblcuOrg) {
          this.showOrgCC = false;
          this.selectedOrgCategory = [];
          return;
        } else {
          this.showOrgCC = true;
        }
        //http://localhost:8080/news/index
        if(val == undefined) {
          val = '';
        }
        let params = {
          orgCode: val
        };
        this.https.fetchPost('/courseCategoryInfo/selectListRecursion', params, 'json').then((data) => {
          this.categoryOrgOptions = [];
          let code = data.data.code;
          let msg = data.data.msg;
          if(code == 200) {
            if(data.data.data != null) {
              this.categoryOrgOptions = data.data.data;
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }
        }).catch(err => {
          console.log(err);
          this.$message.error('网络错误');
        });
      },
      changeCategory(value) {
      },
      remoteMethod(query) {
        if (query !== '') {
          this.loading = true;
          setTimeout(() => {
            this.loading = false;
            this.teacherData = this.teacherList.filter(item => {
              return item.teacherName.toLowerCase().indexOf(query.toLowerCase()) > -1;
            });
            for (let i in this.teacherData1) {
              let flag = true;
              for (let j in this.teacherData) {
                if (this.teacherData1[i].teacherId == this.teacherData[j].teacherId) {
                  flag = false;
                }
              }
              if (flag) {
                this.teacherData.push(this.teacherData1[i]);
              }

            }
          }, 200);


        } else {
          this.teacherData = [];
        }
      },
      selectLecturer(value) {
        let teacherData1 = [];
        for (let i in this.teacherData) {
          for (let j in value) {
            if (value[j] == this.teacherData[i].teacherId) {
              teacherData1.push(this.teacherData[i]);
            }
          }
        }
        this.teacherData1 = teacherData1;
      },
      changeOrgCode(val) {
        if(val ==this.$store.state.eblcuOrg) {
          this.showOrgCC = false;
        } else {
          this.showOrgCC = true;
        }
        this.teacherData = [];
        this.form.lecturer = [];
        this.searchTeacher(val);
        this.selectCategoryData(val);
        
        // this.searchCourseType();
      },
      changeCourse(val) {
        if(val.length > 0) {
          let courseTypeId = val[val.length-1];
          this.searchCourse(courseTypeId);
        }
      },
      searchCourse(courseTypeId) {
        if (!courseTypeId) {
          return;
        }
        let params = {
          courseTypeId: courseTypeId
        };
        this.https.fetchPost('/course/getCourseByTypeId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            let courseList = data.data.data;
            this.courseList = courseList;
            let flag = false;
            for (let index in courseList) {
              if (this.form.courseId == courseList[index].courseId) {
                this.courseName = courseList[index].name;
                flag = true;
              }
            }
            if (!flag) {
              this.form.courseId = '';
            }
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      searchCourseType() {
        let params = {
          orgCode: this.form.orgCode
        };
        this.https.fetchPost('/courseType/courseTypeOfCourseCheck', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.courseOptions = data.data.data.childNodeLst;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      
      
      
      querySearch(queryString, cb) {
        var restaurants = this.courseList;
        var results = queryString ? restaurants.filter(this.createFilter(queryString)) : restaurants;
        cb(results);
      },
      createFilter(queryString) {
        return (restaurant) => {
          return (restaurant.name.toLowerCase().indexOf(queryString.toLowerCase()) != -1);
        };
      },
      handleSelect(item) {
        this.form.courseId = item.courseId;
        this.courseName = item.name;
      },
      searchTeacher(val) {
        ///managerTeacher/getOrganizationList
        let params = {
          orgCode: val
        };
        this.https.fetchGet('/managerTeacher/getOrganizationList', params).then((data) => {
          let code = data.data.code;
          if (code == 200) {
            this.teacherList = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: '加载失败:' + msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      selectOrg() {
        this.https.fetchGet('/managerOrganization/getOrganizationList', '', 'from').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.org = data.data.data;
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
 
      
      getPlayUrl(video) {
        this.videoSrc = video.filePath;
        this.videoType = video.videoType;
        this.uploadMethodDataType = 2;
        /*let params = {
          videoInfoId: fileId
        };
        this.https.fetchPost('/file/getPlayUrl', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
            this.videoSrc = data.data.data.url;
            this.uploadMethodDataType = 2;
            this.selectPlayer();
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );*/
      },
      selectCourseById(courseId){//获取课程信息
        let params = {
          courseId: courseId
        };
        this.https.fetchPost('/course/selectCourseById/'+courseId, '', 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
              let courseData = data.data.data;
              if(courseData.categoryThree>0){
                this.selectedCourse=courseData.categoryThree;
              }
              else if(courseData.categoryTwo>0){
                this.selectedCourse=courseData.categoryTwo;
              }
              else{
                this.selectedCourse=courseData.categoryOne;
              }
              //this.searchCourse(this.selectedCourse);
          }
          else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
       searchCommodityinfoByAll(){//获取课程信息
        this.selectedCategory='';
        let params = {
          all: this.form.courseName
        };
        this.https.fetchPost('/commodityInfo/searchCommodityinfoByAll', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          if (code == 200) {
              let commodityData = data.data.data;
              let commodityIds = [];
              if(commodityData){
                commodityIds.push(commodityData.ccId);
                this.selectedCategory=commodityData.ccId;
              }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      changeSpecType() {
        this.modelTypeList = [];
        this.modelTypeListData = [];
        this.form.skuPriceVoList = [];
        this.form.skuSpecVoList = [];
        this.form.skuCombinedPriceVoList = [];
        for(let tag of this.commodityTags) {
          tag.price = "";
        }
      },
      checkValidity(value){
        this.form.validityType = 2;
      },
      changeCombinedCommodityList(combinedCommodityList) {
        this.form.combinedCommodityList = combinedCommodityList;
      },
      makeModelTypeListData() {
        let skuPriceVoList = [];
        for(let data of this.modelTypeListData) {
          let skuPriceVo = {};
          let fieldTemp = {};
          const fields =  Object.keys(data);
          for(let field of fields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1 && field.indexOf('status') == -1) {
              fieldTemp[field] = data[field];
            }
          }
          let jsonData = JSON.stringify(fieldTemp);
          console.log('aaaaa',jsonData);
          skuPriceVo.attributeName = jsonData;
          skuPriceVo.price = data.price;
          skuPriceVo.preferentialPrice = data.preferentialPrice;
          skuPriceVo.status = data.status;
          if(data.skuId) {
            skuPriceVo.skuId = data.skuId;
          }
          skuPriceVoList.push(skuPriceVo);
        }
        this.form.skuPriceVoList = skuPriceVoList;
      },
      changeSkuCombinedPriceVoList(skuCombinedPriceVoList) {
        this.form.skuCombinedPriceVoList = skuCombinedPriceVoList;
      },
      changeModelTypeList(modelTypeList) {
        this.form.skuSpecVoList = modelTypeList;
        this.modelTypeListMain = modelTypeList;
      },
      
      selectCommodityDetail(commodityId) {
        let params = {
          commodityId: commodityId
        };
        this.https.fetchPost('/commodityInfo/getByCommodityId', params, 'json').then((data) => {
          let code = data.data.code;
          let msg = data.data.msg;
          console.log(data.data,'data.datadata.dataly');
          if (code == 200) {
            this.pageTitle='修改商品';
            this.form = data.data.data;
            this.$set(this.form, 'lecturer', []);
            if (this.form.courseId) {
              this.form.courseId = parseInt(this.form.courseId);
              this.courseList.push({
                courseId: this.form.courseId,
                name: this.form.courseView
              });
            }
            
            this.initCombinedCommodityList(this.form.combinedCommodityList)
            this.skuPriceVoListTemp = JSON.parse(JSON.stringify(this.form.skuPriceVoList));
            if(this.form.skuSpecVoList) {
              for(let skuSpecVo of this.form.skuSpecVoList) {
                let modelType = {};
                if(skuSpecVo.specOptionVoList) {
                  let specOption = [];
                  for(let sku of skuSpecVo.specOptionVoList) {
                    let spec = {}
                    spec.skuSpecOptionId = sku.skuSpecOptionId;
                    spec.specOptionName = sku.specOptionName;
                    spec.specOptionNameEn = sku.specOptionNameEn;
                    spec.specOptionNameRus = sku.specOptionNameRus;
                    spec.specOptionNameSpa = sku.specOptionNameSpa;
                    spec.key = Date.now()+sku.skuSpecOptionId;
                    specOption.push(spec);
                  }
                  modelType.specOptionVoList = specOption;
                  modelType.skuSpecId = skuSpecVo.skuSpecId;
                  modelType.specName = skuSpecVo.specName;
                  modelType.specNameEn = skuSpecVo.specNameEn;
                  modelType.specNameRus = skuSpecVo.specNameRus;
                  modelType.specNameSpa = skuSpecVo.specNameSpa;
                }
                
                this.modelTypeList.push(modelType)
              }
              this.initModelTypeData();
            }
            this.skuCombinedPriceVoTempList = JSON.parse(JSON.stringify(this.form.skuCombinedPriceVoList));
            
            
            let pictureFile = {
              name: this.form.picturePathView,
              url: this.form.picturePathView
            };
            this.pictureFileList.push(pictureFile);
            this.hidePictureUpload = this.pictureFileList.length >= this.pictureLimitCount;
            let auditionVideoFile = {};
            if(this.form.auditionVideoVo) {
              auditionVideoFile = {
                name: this.form.auditionVideoVo.fileName,
                url: this.form.auditionVideoVo.filePath
              };
              this.auditionVideoFileList.push(auditionVideoFile);
              this.getPlayUrl(this.form.auditionVideoVo);
            }
            this.hideAuditionVideoUpload = this.auditionVideoFileList.length >= this.auditionVideoLimitCount;
            if(this.form.preferentialBeginTime) {
              this.form.preferentialBeginTime = this.form.preferentialBeginTime;
            }
            if(this.form.preferentialEndTime) {
              this.form.preferentialEndTime = this.form.preferentialEndTime;
            }
            let commodityLecturerList = this.form.commodityLecturerList;
            if(this.form.ccIdString != null) {
              this.selectedCategory = this.form.ccIdString.split('/');
            }
            if(this.form.orgCcIdString != null) {
              this.selectedOrgCategory = this.form.orgCcIdString.split('/');
            }
            this.selectCategoryData(this.form.orgCode);
            for (let i in commodityLecturerList) {
              this.form.lecturer.push(commodityLecturerList[i].lecturer);
              let teacher = {
                teacherName: commodityLecturerList[i].lecturerName,
                teacherId: commodityLecturerList[i].lecturer
              };
              this.teacherData.push(teacher);
              this.teacherData1.push(teacher);
            }
            let validity = this.form.validity;
            if (validity == -1) {
              //this.$set(this.form, 'validityType', 1);
              this.form.validity = '';
              this.$set(this.form, 'validityType', 1);
            } else {
              this.$set(this.form, 'validityType', 2);
            }

            let openClassTime = this.form.openClassTime;
            if (openClassTime == -28800000) {
              this.$set(this.form, 'openClassType', 1);
              this.form.openClassTime = dateFormat(new Date());
            } else {
              this.$set(this.form, 'openClassType', 2);
              this.form.openClassTime = dateFormat(this.form.openClassTime)
            }
            // if(this.form.courseId){
            //   this.selectCourseById(this.form.courseId);
            // }
            if (this.form.orgCode) {
              this.searchTeacher(this.form.orgCode);
              this.searchCourseType();
              this.selectCategoryData(this.form.orgCode);
            }
          } else {
            this.$message({
              type: 'info',
              message: msg
            });
          }

        }).catch(err => {
              console.log(err);
              this.$message.error('网络错误');
            }
        );
      },
      addRule(prop, rule) {
        this.$set(this.rules, prop, rule);
      },
      validateNumber(value,collback) {

        value = value.replace(/[^\d.]/g,''); // 清除"数字"和"."以外的字符
        value = value.replace(/^\./g,''); // 验证第一个字符是数字
        value = value.replace(/\.{2,}/g,'.'); // 只保留第一个, 清除多余的
        value = value.replace('.','$#$').replace(/\./g,'').replace('$#$','.');
        // 保存n个小数
        value = value.replace(/^(\-)*(\d+)\.(\d{2}).*$/,'$1$2.$3');         // 只能输入n个小数
        if(value.indexOf('.') < 0 && value !=''){
          value = parseFloat(value);
          value = (value+'').substr(0,6);
        } else {
          let value1 = value.substr(0,value.indexOf('.')).substr(0,6);
          let value2 = value.substr(value.indexOf('.'));
          value = value1+value2;
        }
        value = isNaN(value) ? 0 : value; // 不让显示NAN
      
        collback(value);
      },
      changeAuditionVideoStrList(auditionVideoStrList) {
        this.form.auditionVideoStrList = auditionVideoStrList;
      },

      addModelTypeList() {
        if(this.modelTypeList.length >=3) {
          this.$message({
            type: 'info',
            message: '最多添加三种型号分类！'
          });
          return;
        }
        const date = Date.now();
        let  modelType = {
          id: date,
          field: 'field'+date,
          specName: '',
          specNameEn: '',
          specNameRus: '',
          specNameSpa: '',
          specOptionVoList: [],
          inputVisible: false,
          inputValue: "",
          inputValue2: '',
          inputValue3: '',
          inputValue4: '',
          ref: ''
        };

        this.modelTypeList.push(modelType);
      },
      handleModelTypeInputConfirmEn(modelType) {
        if(modelType.specNameEn.length > 200) {
          this.$message({
            type: 'info',
            message: '型号分类英文名称长度最大200个字符！'
          });
          modelType.specNameEn = modelType.specNameEn.substr(0,200);
          return;
        }
      },
      handleModelTypeInputConfirm(modelType) {
        if(modelType.specName.length > 200) {
          this.$message({
            type: 'info',
            message: '型号分类名称长度最大200个字符！'
          });
          modelType.specName = modelType.specName.substr(0,200);
        }
        for(const data of this.modelTypeListData) {
          if(modelType.id == data.id) {
            data.specName = modelType.specName;
          }
        }
      },
      handleModelTypeInputConfirmRus(modelType) {
        if(modelType.specNameRus.length > 200) {
          this.$message({
            type: 'info',
            message: '型号分类俄语名称长度最大200个字符！'
          });
          modelType.specNameRus = modelType.specNameRus.substr(0,200);
        }
        for(const data of this.modelTypeListData) {
          if(modelType.id == data.id) {
            data.specNameRus = modelType.specNameRus;
          }
        }
      },
      handleModelTypeInputConfirmSpa(modelType) {
        if(modelType.specNameSpa.length > 200) {
          this.$message({
            type: 'info',
            message: '型号分类西班牙语名称长度最大200个字符！'
          });
          modelType.specNameSpa = modelType.specNameSpa.substr(0,200);
        }
        for(const data of this.modelTypeListData) {
          if(modelType.id == data.id) {
            data.specNameSpa = modelType.specNameSpa;
          }
        }
      },      
      showInput(modelType) {
        if(modelType.specOptionVoList.length >= 20) {
          this.$message({
            type: 'info',
            message: '最多添加20个型号！'
          });
          return;
        }
        modelType.inputVisible = true;
        this.typeTagShow = true;
        // this.$nextTick(_ => {
        //   this.$refs.saveTagInput[0].$refs.input.focus();
        // });
      },
      handleInputConfirm(modelType) {
        let inputValue = modelType.inputValue;
        let inputValue2 = modelType.inputValue2;
        let inputValue3 = modelType.inputValue3;
        let inputValue4 = modelType.inputValue4;

        if(inputValue && inputValue.length > 200) {
          this.$message({
            type: 'info',
            message: '型号名称长度最大200个字符！'
          });
          return
        }
        if(inputValue2 && inputValue2.length > 200) {
          this.$message({
            type: 'info',
            message: '型号英文名称长度最大200个字符！'
          });
          return
        }
        
        for(let specOption of modelType.specOptionVoList) {
          if(specOption.specOptionName == inputValue) {
            this.$message({
              type: 'info',
              message: '型号重复！'
            });
            return
          }
          if(inputValue2 != '' && inputValue2 != null && specOption.specOptionNameEn == inputValue2) {
            this.$message({
              type: 'info',
              message: '英文型号重复！'
            });
            return
          }
          if(inputValue3 != '' && inputValue3 != null && specOption.specOptionNameRus == inputValue3) {
            this.$message({
              type: 'info',
              message: '俄语型号重复！'
            });
            return
          }
          if(inputValue4 != '' && inputValue4 != null && specOption.specOptionNameSpa == inputValue4) {
            this.$message({
              type: 'info',
              message: '西班牙语型号重复！'
            });
            return
          }
        }

        let data;
        if (inputValue) {
          data = {
            key: Date.now(),
            specOptionName: inputValue,
            specOptionNameEn: inputValue2,
            specOptionNameRus: inputValue3,
            specOptionNameSpa: inputValue4,
            status: 1,
          };
          modelType.specOptionVoList.push(data);
        }
        modelType.inputVisible = false;
        modelType.inputValue = '';
        modelType.inputValue2 = '';
        modelType.inputValue3 = '';
        modelType.inputValue4 = '';
        this.changeModelTypeListData();
      },
      handleTagClose(tag, dynamicTags) {
        dynamicTags.splice(dynamicTags.indexOf(tag), 1);
        this.changeModelTypeListData();
      },
      deleteModelType(modelType) {
        const index = this.modelTypeList.indexOf(modelType);
        this.modelTypeList.splice(index,1);
        this.changeModelTypeListData();
      },

      makeupTable(columns,fieldName) {
        let modelTypeListDataTemp = [];
        if(this.modelTypeListData.length == 0) {
          for(const column of columns) {
            const d = {
              preferentialPrice: '',
              price: '',
            };
            d[fieldName] = column.specOptionName;
            if(column.status) {
              d.status = column.status;
            } else {
              this.$set(d,'status',1);
            }
            modelTypeListDataTemp.push(d);
          }
        } else {
          for(const data of this.modelTypeListData) {
            for(const column of columns) {
              const d = JSON.parse(JSON.stringify(data));
              d[fieldName] = column.specOptionName;
              if(column.status) {
                d.status = column.status;
              } else {
                this.$set(d,'status',1);
              }
              modelTypeListDataTemp.push(d);
            }
          }
        }

        this.modelTypeListData = modelTypeListDataTemp;
      },


      changeModelTypeListData() {
        let modelTypeListDataTemp = JSON.parse(JSON.stringify(this.modelTypeListData));
        this.modelTypeListData = [];
        if(this.modelTypeList.length == 0) {
          this.value1 = '';
          this.value2 = '';
          return;
        }
        for(const modelType of this.modelTypeList) {
          if(modelType.specOptionVoList.length > 0) {
            this.makeupTable(modelType.specOptionVoList, modelType.specName);
          }
        }
        console.log(this.modelTypeListData);
        if(this.modelTypeListData.length == 0) {
          this.value1 = '';
          this.value2 = '';

        }

        for(let m of this.modelTypeListData) {
          let newValFieldTemp = {};
          const fields =  Object.keys(m);
          for(let field of fields) {
            if(field.indexOf('rice') == -1  && field.indexOf('status') == -1) {
              newValFieldTemp[field] = m[field];
            }
          }
          let s = JSON.stringify(newValFieldTemp);
          for(let modelTypeListData of this.skuPriceVoListTemp) {
            if(modelTypeListData.attributeName == s) {
              this.$set(m,"price", modelTypeListData.price);
              this.$set(m,"skuId", modelTypeListData.skuId);
              this.$set(m,"status", modelTypeListData.status);
              this.$set(m,"preferentialPrice", modelTypeListData.preferentialPrice);
            }
          }
        }

        for(let skuPrice of modelTypeListDataTemp) {
          const fieldTemp = {};
          const fieldTemp1 = {};

          const skuPriceFields =  Object.keys(skuPrice);
          for(let field of skuPriceFields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1 && field.indexOf('status') == -1) {
              fieldTemp1[field] = skuPrice[field];
            }
          }
          
          for(let data of this.modelTypeListData) {
            const fields1 =  Object.keys(data);
            for(let field of fields1) {
              if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1 && field.indexOf('status') == -1) {
                fieldTemp[field] = data[field];
              }
            }
            let s = JSON.stringify(fieldTemp);
            let s1 = JSON.stringify(fieldTemp1);
            if(s == s1) {
              for(let field of skuPriceFields) {
                if(field.indexOf('price') > -1) {
                  
                  data[field] = skuPrice[field];
                }
              }
            }
          }
        }
        this.changePrice1();
        this.rowspan();
      },
      rowspan() {
        this.spanArr = {a:1};
        this.position = {a:1};
        let that = this;
        this.modelTypeListData.forEach((item,index) => {

          const fields =  Object.keys(item);
          if(index === 0) {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1 && field.indexOf('status') == -1 && field.indexOf('skuId')) {
                that.spanArr[field] = [1];
                that.position[field] = 0;
              }
            });

          } else {
            fields.forEach((field) => {
              if(field.indexOf('rice') == -1 && field.indexOf('status') == -1 && field.indexOf('skuId')) {
                if(that.modelTypeListData[index][field] === that.modelTypeListData[index-1][field] ){
                  that.spanArr[field][this.position[field]] += 1;
                  that.spanArr[field].push(0);
                }else{
                  that.spanArr[field].push(1);
                  that.position[field] = index;
                }
              }
            });
          }

        });
      },
      resetPrice1() {
        this.value1 = '';
      },
      resetPrice2() {
        this.value2 = '';
      },

      inputBlur1() {
        for(const data of this.modelTypeListData) {
          data.preferentialPrice = this.value1;
        }
      },
      inputBlur2() {
        for(const data of this.modelTypeListData) {
          data.price = this.value2;
        }
      },
      changeCommodityList1(choseCommoditys) {
        if(this.form.skuCombinedPriceVoList.length > choseCommoditys.length) {
          for(let i=0; i<this.form.skuCombinedPriceVoList.length -choseCommoditys.length; i++) {
            this.form.skuCombinedPriceVoList.pop();
          }
        }
        this.commodityTags = [];
        for(let commodity of choseCommoditys) {
          let tag = {};
          tag.courseName = commodity.courseName;
          tag.commodityId = commodity.commodityId;
          if(this.form.specType == 0) {
            let index = choseCommoditys.indexOf(commodity);
            if(index < this.form.skuCombinedPriceVoList.length) {
              this.$set(tag, 'price', this.form.skuCombinedPriceVoList[index].price);
            }
          }
          this.commodityTags.push(tag);
        }

        if(this.specType == 1) {

        }

        let commbinedCommodityList = [];
        for(let commodity of choseCommoditys) {
          let combinedCommodity = {};
          combinedCommodity.commbinedCommodityId = commodity.commodityId;
          commbinedCommodityList.push(combinedCommodity);
        }
        this.form.combinedCommodityList = commbinedCommodityList;

      },
      sortDynamicTags(evt,modelType,index) {
        let oldValue = modelType.specOptionVoList[evt.oldIndex];
        modelType.specOptionVoList.splice(evt.oldIndex,1);
        modelType.specOptionVoList.splice(evt.newIndex,0,oldValue);
        this.changeModelTypeListData();
      },
      name_formatter(item , e, row, index) {
        return '组合'+(index+1) + '个';
      },
      initCombinedCommodityList(newVal) {
        this.commodityList = [];
        for(let combinedCommodity of newVal) {
          let commodity = {};
          commodity.recommendName = combinedCommodity.commbinedCommodityName;
          commodity.recommendId = combinedCommodity.commbinedCommodityId;
          this.commodityList.push(commodity);
        }
        this.commodityTags = JSON.parse(JSON.stringify(newVal));
        if(this.form.specType == 0) {
          for(let i in this.form.skuCombinedPriceVoList) {
            // this.commodityTags[i].price = this.skuCombinedPriceVoTempList[i].price;
            let commodityTag = this.commodityTags[i];
            this.$set(commodityTag, 'price', this.form.skuCombinedPriceVoList[i].price);
          }
        }
        if(this.form.spceType == 1) {

        }
      },
      titleHeader(h, { column, $index }) {
        return h('span',{
          domProps: {
            innerHTML: '组合'+(column.index+1)+'个'
          }
        });
      },
      changePrice1() {
        let skuPriceVoList = [];
        for(let data of this.modelTypeListData) {
          let skuPriceVo = {};
          let fieldTemp = {};
          const fields =  Object.keys(data);
          for(let field of fields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1 && field.indexOf('status') == -1) {
              fieldTemp[field] = data[field];
            }
          }
          let jsonData = JSON.stringify(fieldTemp);
          skuPriceVo.attributeName = jsonData;
          for(let i in this.commodityTags) {
            let temp = JSON.parse(JSON.stringify(skuPriceVo));
            temp['price'] = data['price'+(Number.parseInt(i)+1)];
            temp['combinedCommoditNum'] = Number.parseInt(i)+1;
            skuPriceVoList.push(temp);
          }
        }
        this.form.skuCombinedPriceVoList = skuPriceVoList;
      },

      changePrice() {
        let skuCombinedPriceVoList = [];
        for(let commodity of this.commodityTags) {
          let combinedCommoditNum = this.commodityTags.indexOf(commodity)+1;
          let skuCombinedPrice = {};
          skuCombinedPrice.combinedCommoditNum = combinedCommoditNum;
          skuCombinedPrice.price = commodity.price?Number.parseFloat(commodity.price):0;
          skuCombinedPriceVoList.push(skuCombinedPrice);
        }
        this.form.skuCombinedPriceVoList = skuCombinedPriceVoList;
      },
      initModelTypeData() {
        this.modelTypeListData = [];
        if(this.modelTypeList.length == 0) {
          return;
        }
        for(const modelType of this.modelTypeList) {
          this.makeupTable(modelType.specOptionVoList, modelType.specName);
        }

        for(let m of this.modelTypeListData) {
          let newValFieldTemp = {};
          const fields =  Object.keys(m);
          for(let field of fields) {
            if(field.indexOf('rice') == -1 && field.indexOf('skuId') == -1 && field.indexOf('status') == -1) {
              newValFieldTemp[field] = m[field];
            }
          }
          let s = JSON.stringify(newValFieldTemp);
          for(let modelTypeListData of this.form.skuPriceVoList) {
            if(modelTypeListData.attributeName == s) {
              this.$set(m,"price", modelTypeListData.price);
              this.$set(m,"skuId", modelTypeListData.skuId);
              this.$set(m,"status", modelTypeListData.status);
              this.$set(m,"preferentialPrice", modelTypeListData.preferentialPrice);
            }
          }
          
          for(let skuCombinedPrice of this.form.skuCombinedPriceVoList) {
            if(skuCombinedPrice.attributeName == s) {
              this.$set(m,"price"+skuCombinedPrice.combinedCommoditNum, skuCombinedPrice.price);
            }
          }
        }
        console.log(this.modelTypeListData);
        this.rowspan();
      },
    },
    watch: {
      'form.preferentialBeginTime': {
        immediate: true,
        handler (newVal) {
          console.log(new Date(this.form.preferentialBeginTime).getTime());
          if (this.form.preferentialBeginTime || this.form.preferentialEndTime) {
            this.addRule('preferential', [{ required: true, message: '请输入优惠价', trigger: 'blur' },{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
            
          } else {
            this.addRule('preferential', [{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
          }
          
          if(this.form.preferentialBeginTime) {
            this.addRule('preferentialEndTime', [{ required: true, message: '请输入优惠截止时间', trigger: 'blur' }]);
            this.preferentialTime = 'preferentialEndTime';
            // this.endTimeHoursRule = this.form.preferentialBeginTime.substr(11)+" - " + "23:59:59";
          }else {
            // this.addRule('preferentialEndTime', []);
            this.endTimeHoursRule = '00:00:00 - 23:59:59';
          }
        }
      },
      'form.preferentialEndTime': {
        immediate: true,
        handler (newVal) {
          if (this.form.preferentialBeginTime || this.form.preferentialEndTime) {
            this.addRule('preferential', [{ required: true, message: '请输入优惠价', trigger: 'blur' },{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
            // this.addRule('preferentialBeginTime', [{ required: true, message: '请输入优惠开始时间', trigger: 'blur' }]);
          } else {
            this.addRule('preferential', [{validator: validate.validatePreferentialPrice, trigger: 'blur'}]);
            // this.addRule('preferentialBeginTime', [])
          }

          if(this.form.preferentialEndTime) {
            // this.addRule('preferentialBeginTime', [{ required: true, message: '请输入优惠开始时间', trigger: 'blur' }]);
            // let tiem = "00:00:00"+" - "+ this.form.preferentialEndTime.substr(11);
            // console.log(tiem);
            // this.startTimeHoursRule = tiem;
            // console.log(this.startTimeHoursRule);
          }else {
            // this.addRule('preferentialBeginTime', []);
            this.startTimeHoursRule = '00:00:00 - 23:59:59';
          }
        }
      },
      commodityTags: function(newVal) {
        if(this.form.specType == 0) {
          this.changePrice();
        }
        if(this.form.specType == 1) {
          this.changePrice1();
        }
      },
      
    },
    created: function() {
      
      let commodityId = this.$route.query.commodityId;
      if(commodityId) {
        this.glSearchData.excludeId = commodityId;
        this.searchData.excludeId = commodityId;
        this.selectCommodityDetail(commodityId);
      }
      // 机构编码-远汉      blcuonline
      this.loginOrgCode = this.$store.state.orgCode;
      if(this.loginOrgCode == 'blcuonline') {
        this.form.lessonType = 11;
        this.form.orgCode = 'blcuonline';
        this.changeOrgCode('blcuonline');
      }
      this.selectCategoryData(this.loginOrgCode);
      this.orgType = this.$store.state.orgType;
      if(this.orgType!=1){
        this.showOrgCC=true;
        this.form.orgCode = this.$store.state.orgCode;
      }
     
      this.loadCourseCategory();
      
      this.selectOrg();
      // this.searchCourse(this.form.ccId, dataForm.courseId);
      this.uploadURL = this.https.baseURL + '/file/fdfs_upload';
      this.uploadURLP = this.https.baseURL + '/resources/updateResourceFile';
    }
    
  };
</script>
<style>
  .specParent .el-form-item__content{
    margin-left: 46px !important;
  }

  .specParent .el-form-item__content .el-form-item__label{
    width: 86px !important;
  }

</style>
<style scoped>
  .avatar-uploader {
    width: 500px;
  }
  
  .t_top {
    margin-bottom: 10px;
  }
  
  .t_center {
    /* width: 60%; */
    width: 95%;
    margin: 0 auto;
  }
  
  .t_center1 {
    width: 100%;
    margin: 0 auto;
  }
  
  .avatar-uploader {
    width: 95%;
  }
  
  .ql-editor {
    min-height: 300px;
  }
  
  .hide .el-upload--picture-card {
    display: none;
  }
  .ql-snow .ql-picker.ql-lineheight {
    width: 70px;
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-label::before {
    content: '行高';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='initial']::before {
    content: '默认';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1']::before {
    content: '1';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.5']::before {
    content: '1.5';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='1.75']::before {
    content: '1.75';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='2']::before {
    content: '2';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='3']::before {
    content: '3';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='4']::before {
    content: '4';
  }
  .ql-snow .ql-picker.ql-lineheight .ql-picker-item[data-value='5']::before {
    content: '5';
  }
  .el-tag{
    cursor: pointer;
  }
  .el-tag + .el-tag {
    margin-left: 10px;
  }
  .button-new-tag {
    margin-left: 10px;
    height: 32px;
    line-height: 30px;
    padding-top: 0;
    padding-bottom: 0;
  }
  .input-new-tag {
    width: 90px;
    margin-left: 10px;
    vertical-align: bottom;
  }
  .el-table th {
   padding: 0;
  }
  .el-table .cell, .el-table th div, .el-table--border td:first-child .cell, .el-table--border th:first-child .cell {
    padding-left: 0;
  }
  .el-table .cell, .el-table th div {
    padding-right: 0;
  }
</style>

